// extracted by mini-css-extract-plugin
export default {"settingsWrapper":"SettingsPage_settingsWrapper__C6HSw"};